import { useContext, useMemo } from 'react';

import { useTheme } from '@mui/material';

import { UserTypeContext } from '@/shared/lib/UserTypeContext/UserTypeContext';

export const useModuleGroupRowColor = () => {
  const userType = useContext(UserTypeContext);
  const { palette } = useTheme();

  return useMemo(() => {
    const colorMap = {
      location: { base: palette.purple[50], hover: palette.purple[100] },
      advertiser: { base: palette.magenta[50], hover: palette.magenta[100] },
      service: { base: palette.blue[50], hover: palette.blue[100] },
      backoffice: { base: palette.orange[50], hover: palette.orange[100] },
    };
    return colorMap[userType ?? 'location'] ?? colorMap['location'];
  }, [userType, palette.purple, palette.magenta, palette.blue, palette.orange]);
};
